import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import PhoneFrame from "./components/PhoneFrame";
import HomeScreen from "./screens/HomeScreen";
import RecipientScreen from "./screens/RecipientScreen";
import AmountScreen from "./screens/AmountScreen";
import ConfirmationScreen from "./screens/ConfirmationScreen";
import AuthScreen from "./screens/AuthScreen";
import ProcessingScreen from "./screens/ProcessingScreen";
import SuccessScreen from "./screens/SuccessScreen";
import FailureScreen from "./screens/FailureScreen";
import ActivityScreen from "./screens/ActivityScreen";
import TransactionDetailScreen from "./screens/TransactionDetailScreen";
import ProfileScreen from "./screens/ProfileScreen";
import BottomNav from "./components/BottomNav";
import NotificationsScreen from "./screens/NotificationsScreen";
import LegalScreen from "./screens/LegalScreen";
import SecurityScreen from "./screens/SecurityScreen";
import HelpScreen from "./screens/HelpScreen";
import LandingScreen from "./screens/LandingScreen";

function App() {
  return (
    <div className="App font-body">
      <AppProvider>
        <ThemeProvider attribute="class" defaultTheme="light">
          <Toaster position="top-center" expand={false} richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingScreen />} />
              <Route
                path="*"
                element={
                  <PhoneFrame footer={<BottomNav />}>
                    <AnimatePresence mode="wait">
                      <Routes>
                        <Route path="/demo" element={<HomeScreen />} />
                        <Route path="/send/recipient" element={<RecipientScreen />} />
                        <Route path="/send/amount" element={<AmountScreen />} />
                        <Route path="/send/confirm" element={<ConfirmationScreen />} />
                        <Route path="/send/auth" element={<AuthScreen />} />
                        <Route path="/send/processing" element={<ProcessingScreen />} />
                        <Route path="/send/success" element={<SuccessScreen />} />
                        <Route path="/send/failure" element={<FailureScreen />} />
                        <Route path="/activity" element={<ActivityScreen />} />
                        <Route
                          path="/transaction/:id"
                          element={<TransactionDetailScreen />}
                        />
                        <Route path="/profile" element={<ProfileScreen />} />
                        <Route path="/notifications" element={<NotificationsScreen />} />
                        <Route path="/legal" element={<LegalScreen />} />
                        <Route path="/security" element={<SecurityScreen />} />
                        <Route path="/help" element={<HelpScreen />} />
                      </Routes>
                    </AnimatePresence>
                  </PhoneFrame>
                }
              />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AppProvider>
    </div>
  );
}

export default App;
